export default __webpack_public_path__ + "static/media/November2011.d2166dbd.png";